import authReducer from '@application/features/auth/authSlice';
import loadingReducer from '@application/features/common/loadingSlice';
import companyReducer from '@application/features/company/companySlice';
import companyThemeReducer from '@application/features/companyTheme/companyThemeSlice';
import eventAnalyticsSlice from '@application/features/eventAnalytics/event-analytics-slice';
import eventDashboardSlice from '@application/features/eventDashboard/eventDashboardSlice';
import { f1IntegrationSlice } from '@application/features/f1Integration/f1Slice';
import familyRelationsReducer from '@application/features/familyRelations/familyRelationsSlice';
import formFieldReducer from '@application/features/formField/formFieldSlice';
import formResponseReducer from '@application/features/formResponse/formResponseSlice';
import formStepsReducer from '@application/features/formSteps/formStepsSlice';
import peopleReducer from '@application/features/people/peopleSlice';
import activityReducer from '@application/features/peopleActivities/peopleActivitiesSlice';
import roleReducer from '@application/features/roles/rolesSlice';
import taskReducer from '@application/features/task/taskSlice';
import collaboratorReducer from '@application/features/collaborator/collaboratorSlice';
import collaboratorTaskReducer from '@application/features/collaboratorTask/collaboratorTaskSlice';
import collaboratorEventReducer from '@application/features/collaboratorEvent/collaboratorEventSlice';
import globalSearchReducer from '@application/features/globalSearch/globalSearchSlice';
import userReducer from '@application/features/user/userSlice';
import VDKEventReducer from '@application/features/vdkEvent/VDKEventSlice';
import vdkEventDocumentReducer from '@application/features/vdkEventDocument/vdkEventDocumentSlice';
import vdkEventResponseReducer from '@application/features/vdkEventResponses/vdkEventResponsesSlice';
import interestsReducer from '@application/features/interests/interestsSlice';
import externalRelationsReducer from '@application/features/externalRelations/externalRelationsSlice';
import mvpsReducer from '@application/features/mvps/mvpsSlice';
import vdkEventLanguagesReducer from '@application/features/vdkEventLanguages/VDKEventLanguagesSlice';
import languagesReducer from '@application/features/languages/languagesSlice';
import eventInterestsReducer from '@application/features/eventInterests/eventInterestsSlice';
import peopleInterestsReducer from '@application/features/peopleInterests/peopleInterestsSlice';
import externalRelationInterestsReducer from '@application/features/externalrelationInterests/externalRelationInterestsSlice';
import notificationPreferencesReducer from '@application/features/notificationPreferences/notificationPreferencesSlice';
import emailPreferencesReducer from '@application/features/emailPreferences/emailPreferencesSlice';
import emailTemplatesReducer from '@application/features/emailTemplates/emailTemplatesSlice';
import notificationsReducer from '@application/features/notifications/notificationsSlice';
import footballReducer from '@application/features/football/footballSlice';
import activityLogReducer from '@application/features/activityLog/activityLogSlice';
import partnerLogsReducer from '@application/features/partnerLogs/partnerLogsSlice';
import partnerEventReducer from '@application/features/partnerEvent/partnerEventSlice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { notificationsHubMiddleware } from './notificationsHubMiddleware';
import partnerReducer from '@application/features/partner/partnerSlice';
import partnerContactPersonReducer from '@application/features/partnerContactPerson/partnerContactPersonSlice';
import ticketsReducer from '@application/features/tickets/ticketsSlice';
import pickupLocationReducer from '@application/features/pickupLocation/pickupLocationSlice';
import pickupLocationVehicleReducer from '@application/features/pickupLocationVehicle/pickupLocationVehicleSlice';
import attendeePickupAssignmentReducer from '@application/features/attendeePickupAssignment/attendeePickupAssignmentSlice';
import faqCategoryReducer from '@application/features/faqCategory/faqCategorySlice';
import faqQuestionReducer from '@application/features/faqQuestion/faqQuestionSlice';
import familyFestAttendeesReducer from '@application/features/familyFest/familyFestAttendeesSlice';
import familyFestPickupLocationReducer from '@application/features/familyFest/familyFestPickupLocationSlice';
import familyFestPickupLocationVehicleReducer from '@application/features/familyFest/familyFestPickupLocationVehicleSlice';
import familyFestPickupAssignmentReducer from '@application/features/familyFest/familyFestPickupAssignmentSlice';
import familyFestParkingSlotReducer from '@application/features/familyFest/familyFestParkingSlotSlice';
import familyFestFaqCategoryReducer from '@application/features/familyFestFaqCategory/familyFestFaqCategorySlice';
import familyFestFaqQuestionReducer from '@application/features/familyFestFaqQuestion/familyFestFaqQuestionSlice';
import familyFestDashboardChartsReducer from '@application/features/familyFest/familyFestDashboardChartsSlice';
import familyFestAccommodationReducer from '@application/features/familyFest/familyFestAccommodationSlice';
import eventVehicleReducer from '@application/features/eventVehicle/eventVehicleSlice';
import transportRouteReducer from '@application/features/transportRoute/transportRouteSlice';
import familyFestPassportReducer from '@application/features/familyFest/familyFestPassportSlice';
import familyFestAnalyticsReducer from '@application/features/familyFest/familyFestAnalyticsSlice';
import familyFestEventSpotsReducer from '@application/features/familyFest/familyFestEventSpotsSlice';
import familyFestCompanyAttendeesReducer from '@application/features/familyFest/familyFestCompanyAttendeesSlice';
import familyFestCompanyAttendeesGridReducer from '@application/features/familyFest/familyFestCompanyAttendeesGridSlice';
import usageManualReducer from '@application/features/usageManual/usageManualSlice';
import emailTemplateSettingsReducer from '@application/features/emailTemplateSettings/emailTemplateSettingsSlice';
const combinedReducers = combineReducers({
    auth: authReducer,
    task: taskReducer,
    role: roleReducer,
    VDKEvent: VDKEventReducer,
    user: userReducer,
    loading: loadingReducer,
    company: companyReducer,
    companyTheme: companyThemeReducer,
    formField: formFieldReducer,
    formSteps: formStepsReducer,
    vdkEventDocument: vdkEventDocumentReducer,
    formResponse: formResponseReducer,
    vdkEventResponse: vdkEventResponseReducer,
    f1Integration: f1IntegrationSlice.reducer,
    eventDashboard: eventDashboardSlice,
    eventAnalytics: eventAnalyticsSlice,
    PeopleActivity: activityReducer,
    vdkEventLanguages: vdkEventLanguagesReducer,
    languages: languagesReducer,
    eventInterests: eventInterestsReducer,
    peopleInterests: peopleInterestsReducer,
    externalRelationInterests: externalRelationInterestsReducer,
    people: peopleReducer,
    familyRelations: familyRelationsReducer,
    collaborator: collaboratorReducer,
    collaboratorTask: collaboratorTaskReducer,
    collaboratorEvent: collaboratorEventReducer,
    globalSearch: globalSearchReducer,
    interests: interestsReducer,
    externalRelations: externalRelationsReducer,
    mvps: mvpsReducer,
    partner: partnerReducer,
    partnerContactPerson: partnerContactPersonReducer,
    activityLog: activityLogReducer,
    partnerLogs: partnerLogsReducer,
    partnerEvent: partnerEventReducer,
    notificationPreferences: notificationPreferencesReducer,
    emailPreferences: emailPreferencesReducer,
    emailTemplates: emailTemplatesReducer,
    notifications: notificationsReducer,
    tickets: ticketsReducer,
    football: footballReducer,
    pickupLocation: pickupLocationReducer,
    pickupLocationVehicle: pickupLocationVehicleReducer,
    attendeePickupAssignment: attendeePickupAssignmentReducer,
    faqCategory: faqCategoryReducer,
    faqQuestion: faqQuestionReducer,
    familyFestAttendees: familyFestAttendeesReducer,
    familyFestPickupLocation: familyFestPickupLocationReducer,
    familyFestPickupLocationVehicle: familyFestPickupLocationVehicleReducer,
    familyFestPickupAssignment: familyFestPickupAssignmentReducer,
    familyFestParkingSlot: familyFestParkingSlotReducer,
    familyFestAccommodation: familyFestAccommodationReducer,
    familyFestDashboardCharts: familyFestDashboardChartsReducer,
    familyFestFaqCategory: familyFestFaqCategoryReducer,
    familyFestFaqQuestion: familyFestFaqQuestionReducer,
    familyFestPassport: familyFestPassportReducer,
    familyFestAnalytics: familyFestAnalyticsReducer,
    familyFestEventSpots: familyFestEventSpotsReducer,
    familyFestCompanyAttendees: familyFestCompanyAttendeesReducer,
    familyFestCompanyAttendeesGrid: familyFestCompanyAttendeesGridReducer,
    eventVehicle: eventVehicleReducer,
    transportRoute: transportRouteReducer,
    usageManual: usageManualReducer,
    emailTemplateSettings: emailTemplateSettingsReducer
});
const rootReducer = (state, action) => {
    if (action.type === 'auth/logout' || action.type === 'auth/logoutApplicationOnly') {
        return combinedReducers(undefined, action);
    }
    return combinedReducers(state, action);
};
export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefault) => getDefault().concat(notificationsHubMiddleware)
});
